const userPrefersReducedMotion = () => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion)');
  return prefersReducedMotion.matches;
}

export default userPrefersReducedMotion;